__turbopack_context__.v({
  "blink": "FlexImages-module-scss-module__2O0O9q__blink",
  "flexImage": "FlexImages-module-scss-module__2O0O9q__flexImage",
  "flexImages": "FlexImages-module-scss-module__2O0O9q__flexImages",
});
